export const EVENTS_LOAD_EVENTS_BEGIN = 'EVENTS_LOAD_EVENTS_BEGIN';
export const EVENTS_LOAD_EVENTS_SUCCESS = 'EVENTS_LOAD_EVENTS_SUCCESS';
export const EVENTS_LOAD_EVENTS_FAILURE = 'EVENTS_LOAD_EVENTS_FAILURE';
export const EVENTS_LOAD_EVENTS_DISMISS_ERROR = 'EVENTS_LOAD_EVENTS_DISMISS_ERROR';
export const EVENTS_LOAD_EVENT_DETAIL_BEGIN = 'EVENTS_LOAD_EVENT_DETAIL_BEGIN';
export const EVENTS_LOAD_EVENT_DETAIL_SUCCESS = 'EVENTS_LOAD_EVENT_DETAIL_SUCCESS';
export const EVENTS_LOAD_EVENT_DETAIL_FAILURE = 'EVENTS_LOAD_EVENT_DETAIL_FAILURE';
export const EVENTS_LOAD_EVENT_DETAIL_DISMISS_ERROR = 'EVENTS_LOAD_EVENT_DETAIL_DISMISS_ERROR';
export const EVENTS_LOAD_PAGE_CONTENT_BEGIN = 'EVENTS_LOAD_PAGE_CONTENT_BEGIN';
export const EVENTS_LOAD_PAGE_CONTENT_SUCCESS = 'EVENTS_LOAD_PAGE_CONTENT_SUCCESS';
export const EVENTS_LOAD_PAGE_CONTENT_FAILURE = 'EVENTS_LOAD_PAGE_CONTENT_FAILURE';
export const EVENTS_LOAD_PAGE_CONTENT_DISMISS_ERROR = 'EVENTS_LOAD_PAGE_CONTENT_DISMISS_ERROR';
export const EVENTS_LOAD_PAGES_IN_EVENT_BEGIN = 'EVENTS_LOAD_PAGES_IN_EVENT_BEGIN';
export const EVENTS_LOAD_PAGES_IN_EVENT_SUCCESS = 'EVENTS_LOAD_PAGES_IN_EVENT_SUCCESS';
export const EVENTS_LOAD_PAGES_IN_EVENT_FAILURE = 'EVENTS_LOAD_PAGES_IN_EVENT_FAILURE';
export const EVENTS_LOAD_PAGES_IN_EVENT_DISMISS_ERROR = 'EVENTS_LOAD_PAGES_IN_EVENT_DISMISS_ERROR';
export const EVENTS_LOAD_DEFAULT_PAGE_BEGIN = 'EVENTS_LOAD_DEFAULT_PAGE_BEGIN';
export const EVENTS_LOAD_DEFAULT_PAGE_SUCCESS = 'EVENTS_LOAD_DEFAULT_PAGE_SUCCESS';
export const EVENTS_LOAD_DEFAULT_PAGE_FAILURE = 'EVENTS_LOAD_DEFAULT_PAGE_FAILURE';
export const EVENTS_LOAD_DEFAULT_PAGE_DISMISS_ERROR = 'EVENTS_LOAD_DEFAULT_PAGE_DISMISS_ERROR';
export const EVENTS_LOAD_COLLECTIONS_IN_EVENT_BEGIN = 'EVENTS_LOAD_COLLECTIONS_IN_EVENT_BEGIN';
export const EVENTS_LOAD_COLLECTIONS_IN_EVENT_SUCCESS = 'EVENTS_LOAD_COLLECTIONS_IN_EVENT_SUCCESS';
export const EVENTS_LOAD_COLLECTIONS_IN_EVENT_FAILURE = 'EVENTS_LOAD_COLLECTIONS_IN_EVENT_FAILURE';
export const EVENTS_LOAD_COLLECTIONS_IN_EVENT_DISMISS_ERROR =
  'EVENTS_LOAD_COLLECTIONS_IN_EVENT_DISMISS_ERROR';
export const EVENTS_LOAD_SNIPPETS_IN_EVENT_BEGIN = 'EVENTS_LOAD_SNIPPETS_IN_EVENT_BEGIN';
export const EVENTS_LOAD_SNIPPETS_IN_EVENT_SUCCESS = 'EVENTS_LOAD_SNIPPETS_IN_EVENT_SUCCESS';
export const EVENTS_LOAD_SNIPPETS_IN_EVENT_FAILURE = 'EVENTS_LOAD_SNIPPETS_IN_EVENT_FAILURE';
export const EVENTS_LOAD_SNIPPETS_IN_EVENT_DISMISS_ERROR =
  'EVENTS_LOAD_SNIPPETS_IN_EVENT_DISMISS_ERROR';
export const EVENTS_CLOSE_ACTION_FORM_MODAL = 'EVENTS_CLOSE_ACTION_FORM_MODAL';
export const EVENTS_DELETE_ACTION_BEGIN = 'EVENTS_DELETE_ACTION_BEGIN';
export const EVENTS_DELETE_ACTION_SUCCESS = 'EVENTS_DELETE_ACTION_SUCCESS';
export const EVENTS_DELETE_ACTION_FAILURE = 'EVENTS_DELETE_ACTION_FAILURE';
export const EVENTS_DELETE_ACTION_DISMISS_ERROR = 'EVENTS_DELETE_ACTION_DISMISS_ERROR';
export const EVENTS_DELETE_EVENT_BEGIN = 'EVENTS_DELETE_EVENT_BEGIN';
export const EVENTS_DELETE_EVENT_SUCCESS = 'EVENTS_DELETE_EVENT_SUCCESS';
export const EVENTS_DELETE_EVENT_FAILURE = 'EVENTS_DELETE_EVENT_FAILURE';
export const EVENTS_DELETE_EVENT_DISMISS_ERROR = 'EVENTS_DELETE_EVENT_DISMISS_ERROR';
export const EVENTS_OPEN_ACTION_PROP_MODAL = 'EVENTS_OPEN_ACTION_PROP_MODAL';
export const EVENTS_SAVE_NEW_ACTION_BEGIN = 'EVENTS_SAVE_NEW_ACTION_BEGIN';
export const EVENTS_SAVE_NEW_ACTION_SUCCESS = 'EVENTS_SAVE_NEW_ACTION_SUCCESS';
export const EVENTS_SAVE_NEW_ACTION_FAILURE = 'EVENTS_SAVE_NEW_ACTION_FAILURE';
export const EVENTS_SAVE_NEW_ACTION_DISMISS_ERROR = 'EVENTS_SAVE_NEW_ACTION_DISMISS_ERROR';
export const EVENTS_SAVE_NEW_EVENT_BEGIN = 'EVENTS_SAVE_NEW_EVENT_BEGIN';
export const EVENTS_SAVE_NEW_EVENT_SUCCESS = 'EVENTS_SAVE_NEW_EVENT_SUCCESS';
export const EVENTS_SAVE_NEW_EVENT_FAILURE = 'EVENTS_SAVE_NEW_EVENT_FAILURE';
export const EVENTS_SAVE_NEW_EVENT_DISMISS_ERROR = 'EVENTS_SAVE_NEW_EVENT_DISMISS_ERROR';
export const EVENTS_UPDATE_ACTION_BEGIN = 'EVENTS_UPDATE_ACTION_BEGIN';
export const EVENTS_UPDATE_ACTION_SUCCESS = 'EVENTS_UPDATE_ACTION_SUCCESS';
export const EVENTS_UPDATE_ACTION_FAILURE = 'EVENTS_UPDATE_ACTION_FAILURE';
export const EVENTS_UPDATE_ACTION_DISMISS_ERROR = 'EVENTS_UPDATE_ACTION_DISMISS_ERROR';
export const EVENTS_UPDATE_EVENT_BEGIN = 'EVENTS_UPDATE_EVENT_BEGIN';
export const EVENTS_UPDATE_EVENT_SUCCESS = 'EVENTS_UPDATE_EVENT_SUCCESS';
export const EVENTS_UPDATE_EVENT_FAILURE = 'EVENTS_UPDATE_EVENT_FAILURE';
export const EVENTS_UPDATE_EVENT_DISMISS_ERROR = 'EVENTS_UPDATE_EVENT_DISMISS_ERROR';
export const EVENTS_TOGGLE_EVENT_UPDATE = 'EVENTS_TOGGLE_EVENT_UPDATE';
export const EVENTS_LOAD_IN_MEMORY_COLLECTION_BEGIN = 'EVENTS_LOAD_IN_MEMORY_COLLECTION_BEGIN';
export const EVENTS_LOAD_IN_MEMORY_COLLECTION_SUCCESS = 'EVENTS_LOAD_IN_MEMORY_COLLECTION_SUCCESS';
export const EVENTS_LOAD_IN_MEMORY_COLLECTION_FAILURE = 'EVENTS_LOAD_IN_MEMORY_COLLECTION_FAILURE';
export const EVENTS_LOAD_IN_MEMORY_COLLECTION_DISMISS_ERROR =
  'EVENTS_LOAD_IN_MEMORY_COLLECTION_DISMISS_ERROR';
export const EVENTS_LOAD_PROJECT_PLUGINS_BEGIN = 'EVENTS_LOAD_PROJECT_PLUGINS_BEGIN';
export const EVENTS_LOAD_PROJECT_PLUGINS_SUCCESS = 'EVENTS_LOAD_PROJECT_PLUGINS_SUCCESS';
export const EVENTS_LOAD_PROJECT_PLUGINS_FAILURE = 'EVENTS_LOAD_PROJECT_PLUGINS_FAILURE';
export const EVENTS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR =
  'EVENTS_LOAD_PROJECT_PLUGINS_DISMISS_ERROR';
export const EVENTS_SWAP_ACTION_STEP_BEGIN = 'EVENTS_SWAP_ACTION_STEP_BEGIN';
export const EVENTS_SWAP_ACTION_STEP_SUCCESS = 'EVENTS_SWAP_ACTION_STEP_SUCCESS';
export const EVENTS_SWAP_ACTION_STEP_FAILURE = 'EVENTS_SWAP_ACTION_STEP_FAILURE';
export const EVENTS_SWAP_ACTION_STEP_DISMISS_ERROR = 'EVENTS_SWAP_ACTION_STEP_DISMISS_ERROR';
export const EVENTS_OPEN_ACTION_ENABLE_MODAL = 'EVENTS_OPEN_ACTION_ENABLE_MODAL';
export const EVENTS_CLOSE_ACTION_ENABLE_MODAL = 'EVENTS_CLOSE_ACTION_ENABLE_MODAL';
export const EVENTS_ENABLE_ACTION_BEGIN = 'EVENTS_ENABLE_ACTION_BEGIN';
export const EVENTS_ENABLE_ACTION_SUCCESS = 'EVENTS_ENABLE_ACTION_SUCCESS';
export const EVENTS_ENABLE_ACTION_FAILURE = 'EVENTS_ENABLE_ACTION_FAILURE';
export const EVENTS_ENABLE_ACTION_DISMISS_ERROR = 'EVENTS_ENABLE_ACTION_DISMISS_ERROR';
export const EVENTS_LOAD_PROJECT_DETAIL_EVENT_BEGIN = 'EVENTS_LOAD_PROJECT_DETAIL_EVENT_BEGIN';
export const EVENTS_LOAD_PROJECT_DETAIL_EVENT_SUCCESS = 'EVENTS_LOAD_PROJECT_DETAIL_EVENT_SUCCESS';
export const EVENTS_LOAD_PROJECT_DETAIL_EVENT_FAILURE = 'EVENTS_LOAD_PROJECT_DETAIL_EVENT_FAILURE';
export const EVENTS_LOAD_PROJECT_DETAIL_EVENT_DISMISS_ERROR =
  'EVENTS_LOAD_PROJECT_DETAIL_EVENT_DISMISS_ERROR';
export const EVENTS_LOAD_DATASOURCES_IN_EVENT_BEGIN = 'EVENTS_LOAD_DATASOURCES_IN_EVENT_BEGIN';
export const EVENTS_LOAD_DATASOURCES_IN_EVENT_SUCCESS = 'EVENTS_LOAD_DATASOURCES_IN_EVENT_SUCCESS';
export const EVENTS_LOAD_DATASOURCES_IN_EVENT_FAILURE = 'EVENTS_LOAD_DATASOURCES_IN_EVENT_FAILURE';
export const EVENTS_LOAD_DATASOURCES_IN_EVENT_DISMISS_ERROR =
  'EVENTS_LOAD_DATASOURCES_IN_EVENT_DISMISS_ERROR';
export const EVENTS_GET_PERMISSION_FLAGS_BEGIN = 'EVENTS_GET_PERMISSION_FLAGS_BEGIN';
export const EVENTS_GET_PERMISSION_FLAGS_SUCCESS = 'EVENTS_GET_PERMISSION_FLAGS_SUCCESS';
export const EVENTS_GET_PERMISSION_FLAGS_FAILURE = 'EVENTS_GET_PERMISSION_FLAGS_FAILURE';
export const EVENTS_GET_PERMISSION_FLAGS_DISMISS_ERROR =
  'EVENTS_GET_PERMISSION_FLAGS_DISMISS_ERROR';
